export const cplaceSingleIconControlAvailableIcons = [
  {
    name: 'fa-ban',
    className: 'fa fa-ban',
  },
  {
    name: 'fa-search',
    className: 'fa fa-search',
  },
  {
    name: 'fa-home',
    className: 'fa fa-home',
  },
  {
    name: 'fa-arrow-right',
    className: 'fa fa-arrow-right',
  },
  {
    name: 'fa-arrow-left',
    className: 'fa fa-arrow-left',
  },
  {
    name: 'fa-apple',
    className: 'fa fa-apple',
  },
  {
    name: 'fa-tree',
    className: 'fa fa-tree',
  },
  {
    name: 'fa-close',
    className: 'fa fa-close',
  },
  {
    name: 'fa-caret-right',
    className: 'fa fa-caret-right',
  },
  {
    name: 'fa-caret-left',
    className: 'fa fa-caret-left',
  },
  {
    name: 'fa-phone',
    className: 'fa fa-phone',
  },
  {
    name: 'fa-plane',
    className: 'fa fa-plane',
  },
];
